module.exports = __webpack_public_path__ + "static/img/PDV-2020-72.003e149.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/PDV-2020-72.png
// module id = 9YZT
// module chunks = 0